/** @format */
import { css } from 'styled-components';

const baseStyles = () => css`
    align-items: flex-start;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-radius: var(--layout-spacing-8);
    gap: var(--layout-spacing-24);
`;

export const styles = () => css`
    ${baseStyles()}
`;
